import { z } from 'zod/v4';

export const StyleListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  codes: z.array(z.string()),
});

export type StyleListItemType = z.infer<typeof StyleListItemSchema>;
